import { FC } from "react";
import { Link } from "react-router-dom";
import { useNavbar } from "./Navbar.hook";
import LogoSvg from "../../static/images/logo.svg";
import "./style.css";

export const Navbar: FC = () => {
  const { links, currentPathname } = useNavbar();

  return (
    <nav className="navbar">
      <div className="navbar-logo-wrapper">
        <img
          src={LogoSvg}
          alt="HCP Logo"
          className="navbar-logo-wrapper-logo"
        />
        <h6>Tools</h6>
      </div>
      <div className="navbar-links">
        {links.map((link) => {
          const linkClassName = `navbar-link ${
            currentPathname === link?.href ? "active" : null
          }`;

          return (
            <Link key={link?.href} to={link?.href} className={linkClassName}>
              {link?.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
